// extracted by mini-css-extract-plugin
export default {"melodyVideo":"CO-z","isFullWidth":"DO-z","landingPageVideo":"EO-z","play":"FO-z","iframeVideo":"GO-z","playHidden":"HO-z","fullwidth":"IO-z"};